export const getNavigatorLanguage = (): string => {
  if (navigator?.languages.length) {
    return navigator.languages[0]
  } else {
    return navigator.language
  }
}
